import Axios from 'axios';

export default {
  createResetPassword(cpf) {
    return Axios.get('/admin/reset-password', { params: { cpf } });
  },
};
